import { defineComponent, inject, Ref } from 'vue';
import RedirectToLogin  from './RedirectToRegister.class';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { setupComponent } from '@studyportals/vue-platform';

export default defineComponent({
	setup: () => {
		const store = inject<IIncentiveV2Store>('incentiveV2Store');
		const isRegister = inject<Ref<boolean>>('isRegister');
		if (!store || !isRegister) {
			throw new Error('Store or isRegister not provided');
		}
		const component = new RedirectToLogin(store, isRegister);
		return setupComponent(component);
	}
});


